// Notifications Tour
// Notification preferences for your team and your customers
// Selector policy: step 1 pins to the live-verified sidebar id (#sb_settings); teaching steps are
// deliberate centered cards — no guessed element selectors.

export const notificationsTour = {
  id: 'notifications',
  name: 'Notifications Tour',
  displayName: 'Get Alerted, Not Buried',
  description: 'Notification preferences for your team and your customers',
  estimatedDuration: '3 minutes',
  category: 'feature',
  autoStart: false,
  prerequisiteTours: ['ftux'],

  config: { animate: true, overlayOpacity: 0.75, smoothScroll: true, allowClose: true, showProgress: true },

  steps: [
    {
      element: '#sb_settings',
      popover: {
        title: "🔔 Welcome to Notifications",
        description: `
          Two kinds matter here: alerts to **your team** so nothing is missed, and messages to **your customers** so they stay informed. Both need tuning.
        `,
        side: 'right',
        align: 'center'
      }
    },

    {
      popover: {
        title: "👥 Team Notifications",
        description: `
          Choose what your team gets told about — new leads, inbound messages, bookings, payments — and on which channel. **Speed to lead** depends on the new-lead alert actually reaching someone.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "🙋 Customer Notifications",
        description: `
          Appointment confirmations and reminders, payment receipts, document requests. These reduce no-shows and support questions more than any other setting.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "🎯 Fewer, Better Alerts",
        description: `
          The most common mistake is alerting on everything. An alert that fires constantly gets dismissed, and then the important one gets dismissed with it.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "📱 Per-Person Preferences",
        description: `
          Each team member can set their own channels. Let people tune their own alerts — they will actually read the ones they kept.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "🎉 Tuned In",
        description: `
          You can now:

✅ Alert your team on what matters
✅ Keep customers informed automatically
✅ Avoid alert fatigue
✅ Let each person set preferences

**Next:** confirm the new-lead alert reaches a human within a minute.
        `,
        side: 'over',
        align: 'center',
        showButtons: ['close'],
        doneBtnText: 'Done →'
      }
    }
  ]
};
